/**
 * Report templates for quick report initialization.
 * Widget IDs must match chart IDs from chartVisibilitySections.
 */

export const reportTemplates = [
  {
    id: 'executive-summary',
    name: 'Executive Summary',
    description: 'Top-level KPIs and performance overview',
    widgets: [
      'platformPerformanceComparison',
      'campaignPerformance',
      'goalPerformance',
      'messages',
    ],
  },
  {
    id: 'marketing-performance',
    name: 'Marketing Performance',
    description: 'Campaigns, paid media, and content performance',
    widgets: [
      'campaignPerformance',
      'platformPerformanceComparison',
      'monthlySocialPerformance',
      'paidMediaPerformance',
      'topPerformingAds',
      'goalPerformance',
      'optimal_posting_times',
      'topPosts',
    ],
  },
  {
    id: 'customer-service',
    name: 'Customer Service',
    description: 'Inbox health, sentiment, and response metrics',
    widgets: [
      'messages',
      'messageSentiment',
      'alerts',
      'timeOfDay',
      'messageHeatmap',
    ],
  },
  {
    id: 'reputation-report',
    name: 'Reputation Report',
    description: 'Social performance and competitor benchmarking',
    widgets: [
      'platformPerformanceComparison',
      'monthlySocialPerformance',
      'goalPerformance',
      'topPosts',
    ],
  },
  {
    id: 'blank',
    name: 'Blank Report',
    description: 'Start with no charts selected',
    widgets: [],
  },
]
